import { ActionPermission } from '../../types'

export function computeEventsPermission(): ActionPermission {
  return 'enabled'
}
